import { arbitrum, mainnet, polygon, bsc, avalanche, celo, base, optimism } from "wagmi/chains";
import {
  ArbitrumIcon,
  BinanceSmartChainIcon,
  EthereumIcon,
  PolygonIcon,
  AvalancheIcon,
  OptimismIcon,
  CeloIcon,
  BaseIcon,
} from "components/Icons";
import { themes } from "styles/theme";
import { BebopChain } from "types/chain";

export const Ethereum: BebopChain = {
  ...mainnet,
  displayName: "Ethereum",
  apiName: "ethereum",
  rpcUrl: "https://api.bebop.xyz/node/eth",
  icon: EthereumIcon,
  iconColor: themes.dark.Networks["Ethereum"],
  blockExplorerUrl: "https://etherscan.io/",
  wrappedTokenAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  coingeckoId: "ethereum",
  permitDomains: {
    "0x6B175474E89094C44Da98b954EedeAC495271d0F": 1,
    "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9": 1,
    "0xba100000625a3754423978a60c9317c58a424e3D": 1,
    "0x92D6C1e31e14520e676a687F0a93788B716BEff5": 1,
    "0xb3999F658C0391d94A37f7FF328F3feC942BcADC": 2,
    "0xc944E90C64B2c07662A292be6244BDf05Cda44a7": 4,
    "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984": 2,
    "0x111111111117dC0aa78b770fA6A738034120C302": 1,
    "0xd1d2Eb1B1e90B638588728b4130137D262C87cae": 1,
    "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48": 1,
    "0x5283D291DBCF85356A21bA090E6db59121208b44": 1,
    "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704": 1,
    "0x321C2fE4446C7c963dc41Dd58879AF648838f98D": 2,
  },
};

export const Polygon: BebopChain = {
  ...polygon,
  displayName: "Polygon",
  apiName: "polygon",
  rpcUrl: "https://api.bebop.xyz/node/polygon",
  icon: PolygonIcon,
  iconColor: themes.dark.Networks["Polygon"],
  blockExplorerUrl: "https://polygonscan.com/",
  wrappedTokenAddress: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
  coingeckoId: "polygon-pos",
  permitDomains: {
    "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174": 3,
    "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063": 3,
  },
};

export const Arbitrum: BebopChain = {
  ...arbitrum,
  displayName: "Arbitrum",
  apiName: "arbitrum",
  rpcUrl: "https://api.bebop.xyz/node/arbitrum",
  icon: ArbitrumIcon,
  iconColor: themes.dark.Networks["Arbitrum"],
  blockExplorerUrl: "https://arbiscan.io/",
  wrappedTokenAddress: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
  coingeckoId: "arbitrum-one",
  permitDomains: {
    "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1": 1,
    "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f": 1,
    "0x539bdE0d7Dbd336b79148AA742883198BBF60342": 1,
    "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9": 1,
    "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8": 1,
  },
};

export const BinanceSmartChain: BebopChain = {
  ...bsc,
  name: "BNB Chain",
  displayName: "BNB Chain",
  apiName: "bsc",
  rpcUrl: "https://bsc-dataseed3.bnbchain.org",
  icon: BinanceSmartChainIcon,
  iconColor: themes.dark.Networks["BinanceSmartChain"],
  blockExplorerUrl: "https://bscscan.com/",
  wrappedTokenAddress: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  coingeckoId: "binance-smart-chain",
  permitDomains: {},
};

export const Avalanche: BebopChain = {
  ...avalanche,
  displayName: "Avalanche",
  apiName: "avalanche",
  rpcUrl: "https://api.avax.network/ext/bc/C/rpc",
  icon: AvalancheIcon,
  iconColor: themes.dark.Networks["Avalanche"],
  blockExplorerUrl: "https://snowtrace.io/",
  wrappedTokenAddress: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
  coingeckoId: "avalanche",
  permitDomains: {},
};

export const Optimism: BebopChain = {
  ...optimism,
  displayName: "Optimism",
  apiName: "optimism",
  rpcUrl: "https://mainnet.optimism.io", // TODO: Consider using viem's rpc urls instead?
  icon: OptimismIcon,
  iconColor: themes.dark.Networks["Optimism"],
  blockExplorerUrl: "https://optimistic.etherscan.io/", // TODO: consider using viem's block explorer?
  wrappedTokenAddress: "0x4200000000000000000000000000000000000006",
  coingeckoId: "optimistic-ethereum",
  permitDomains: {},
};

export const Base: BebopChain = {
  ...base,
  displayName: "Base",
  apiName: "base",
  rpcUrl: "https://mainnet.base.org", // TODO: Consider using viem's rpc urls instead?
  icon: BaseIcon,
  iconColor: themes.dark.Networks["Base"],
  blockExplorerUrl: "https://basescan.org/",
  wrappedTokenAddress: "0x4200000000000000000000000000000000000006",
  coingeckoId: "base",
  permitDomains: {},
};

export const Celo: BebopChain = {
  ...celo,
  displayName: "Celo",
  apiName: "celo",
  rpcUrl: "https://rpc.ankr.com/celo	", // TODO: Consider using viem's rpc urls instead?
  icon: CeloIcon,
  iconColor: themes.dark.Networks["Celo"],
  blockExplorerUrl: "https://celoscan.io/",
  wrappedTokenAddress: "0x471EcE3750Da237f93B8E339c536989b8978a438",
  coingeckoId: "celo",
  permitDomains: {},
};

const CHAINS = {
  [Ethereum.id]: Ethereum,
  [Polygon.id]: Polygon,
  [Arbitrum.id]: Arbitrum,
  [BinanceSmartChain.id]: BinanceSmartChain,
  [Avalanche.id]: Avalanche,
};

const SUPPORTED_CHAINS = [Ethereum, Polygon, Arbitrum, BinanceSmartChain];

export { CHAINS, SUPPORTED_CHAINS };
